<template>
    <div class="spinner-wrapper">
        <div id="spinner-item-1" class="spinner-item"></div>
        <div id="spinner-item-2" class="spinner-item"></div>
        <div id="spinner-item-3" class="spinner-item"></div>
        <div id="spinner-item-4" class="spinner-item"></div>
        <div id="spinner-item-5" class="spinner-item"></div>
        <div id="spinner-item-6" class="spinner-item"></div>
        <div id="spinner-item-7" class="spinner-item"></div>
        <div id="spinner-item-8" class="spinner-item"></div>
    </div>
</template>

<script>
    export default {
        name: "spinner",

        props: {
            color: {
                default: '#FFFFFF'
            }
        },

        mounted() {
            $(this.$el).children().css({
                backgroundColor: this.color
            })
        }
    }
</script>

<style scoped>
    .spinner-wrapper {
        position:relative;
        width:75px;
        height:75px;
        margin: auto;
    }

    .spinner-item {
        position:absolute;
        background-color:rgb(255,255,255);
        width:18px;
        height:18px;
        border-radius:11px;
        -o-border-radius:11px;
        -ms-border-radius:11px;
        -webkit-border-radius:11px;
        -moz-border-radius:11px;
        animation-name:bounce_circularG;
        -o-animation-name:bounce_circularG;
        -ms-animation-name:bounce_circularG;
        -webkit-animation-name:bounce_circularG;
        -moz-animation-name:bounce_circularG;
        animation-duration:0.96s;
        -o-animation-duration:0.96s;
        -ms-animation-duration:0.96s;
        -webkit-animation-duration:0.96s;
        -moz-animation-duration:0.96s;
        animation-iteration-count:infinite;
        -o-animation-iteration-count:infinite;
        -ms-animation-iteration-count:infinite;
        -webkit-animation-iteration-count:infinite;
        -moz-animation-iteration-count:infinite;
        animation-direction:normal;
        -o-animation-direction:normal;
        -ms-animation-direction:normal;
        -webkit-animation-direction:normal;
        -moz-animation-direction:normal;
    }

    #spinner-item-1{
        left:0;
        top:30px;
        animation-delay:0.36s;
        -o-animation-delay:0.36s;
        -ms-animation-delay:0.36s;
        -webkit-animation-delay:0.36s;
        -moz-animation-delay:0.36s;
    }

    #spinner-item-2{
        left:8px;
        top:8px;
        animation-delay:0.48s;
        -o-animation-delay:0.48s;
        -ms-animation-delay:0.48s;
        -webkit-animation-delay:0.48s;
        -moz-animation-delay:0.48s;
    }

    #spinner-item-3{
        top:0;
        left:30px;
        animation-delay:0.6s;
        -o-animation-delay:0.6s;
        -ms-animation-delay:0.6s;
        -webkit-animation-delay:0.6s;
        -moz-animation-delay:0.6s;
    }

    #spinner-item-4{
        right:8px;
        top:8px;
        animation-delay:0.72s;
        -o-animation-delay:0.72s;
        -ms-animation-delay:0.72s;
        -webkit-animation-delay:0.72s;
        -moz-animation-delay:0.72s;
    }

    #spinner-item-5{
        right:0;
        top:30px;
        animation-delay:0.84s;
        -o-animation-delay:0.84s;
        -ms-animation-delay:0.84s;
        -webkit-animation-delay:0.84s;
        -moz-animation-delay:0.84s;
    }

    #spinner-item-6{
        right:8px;
        bottom:8px;
        animation-delay:0.96s;
        -o-animation-delay:0.96s;
        -ms-animation-delay:0.96s;
        -webkit-animation-delay:0.96s;
        -moz-animation-delay:0.96s;
    }

    #spinner-item-7{
        left:30px;
        bottom:0;
        animation-delay:1.08s;
        -o-animation-delay:1.08s;
        -ms-animation-delay:1.08s;
        -webkit-animation-delay:1.08s;
        -moz-animation-delay:1.08s;
    }

    #spinner-item-8{
        left:8px;
        bottom:8px;
        animation-delay:1.2s;
        -o-animation-delay:1.2s;
        -ms-animation-delay:1.2s;
        -webkit-animation-delay:1.2s;
        -moz-animation-delay:1.2s;
    }



    @keyframes bounce_circularG{
        0%{
            transform:scale(1);
        }

        100%{
            transform:scale(.3);
        }
    }

    @-o-keyframes bounce_circularG{
        0%{
            -o-transform:scale(1);
        }

        100%{
            -o-transform:scale(.3);
        }
    }

    @-ms-keyframes bounce_circularG{
        0%{
            -ms-transform:scale(1);
        }

        100%{
            -ms-transform:scale(.3);
        }
    }

    @-webkit-keyframes bounce_circularG{
        0%{
            -webkit-transform:scale(1);
        }

        100%{
            -webkit-transform:scale(.3);
        }
    }

    @-moz-keyframes bounce_circularG{
        0%{
            -moz-transform:scale(1);
        }

        100%{
            -moz-transform:scale(.3);
        }
    }
</style>